import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import TableRow from './table-row';
import SharedIntlProviderHOC from "shared-components/hocs/sharedIntlProviderHOC";

const AttendeePricingTable = ({ listing = {} }) => {
  const tiers = get(listing, 'attendee_pricing.tiers', []);
  const currency = get(listing, 'prices.0.currency', 'USD');
  const country = get(listing, 'country', '');

  return (
    <SharedIntlProviderHOC>
      <div>
        <h5 style={{ marginTop: '32px' }}>
          <FormattedMessage
            id='inbox.attendee_pricing_table.attendee_pricing'
            defaultMessage='Attendee pricing'
          />
        </h5>
        <hr className="pricing-table-border" />
        <div>
          {
            tiers.length ?
              tiers.map(({ min, max, value }) => {
                return (
                  <div>
                    <TableRow
                      leftCol={
                        <div>
                          <div>
                            <FormattedMessage
                              id='inbox.attendee_pricing_table.range_people'
                              defaultMessage='{min} - {max} people'
                              values={{
                                min: min,
                                max: max
                              }}
                            />
                          </div>
                        </div>
                      }
                      rightCol={
                        <div>
                          + <FormattedNumber
                            value={value}
                            currency={currency}
                            style="currency"
                            minimumFractionDigits={0}
                            maximumFractionDigits={0}
                          />
                          <FormattedMessage
                            id='inbox.attendee_pricing_table.per_hour'
                            defaultMessage='/hr'
                          />
                        </div>
                      }
                    />
                    <hr className="pricing-table-border" />
                  </div>
                );
              }) :
              <div>
                <TableRow
                  leftCol={
                    <div>
                      <div>
                        <FormattedMessage
                          id='inbox.attendee_pricing_table.range_guests'
                          defaultMessage='1-{guests} people'
                          values={{
                            guests: get(listing, 'number_guests')
                          }}
                        />
                      </div>
                    </div>
                  }
                  rightCol={
                    <div>
                      + <FormattedNumber
                        value={0}
                        currency={currency}
                        style="currency"
                        minimumFractionDigits={0}
                        maximumFractionDigits={0}
                      />
                      <FormattedMessage
                        id='inbox.attendee_pricing_table.per_hour_right'
                        defaultMessage='/hr'
                      />
                    </div>
                  }
                />
                <hr className="pricing-table-border" />
              </div>
          }
        </div>
      </div>
    </SharedIntlProviderHOC>
  );
};

AttendeePricingTable.propTypes = {
  listing: PropTypes.object.isRequired
};

export default AttendeePricingTable;
